import { Injectable } from '@angular/core';
import { retry, catchError, map } from 'rxjs/operators';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpResponse,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { CommonEventService } from './common-event.service';
import { ApiService } from './api.service';

@Injectable()
export class ApiInterceptorInterceptor implements HttpInterceptor {

  constructor(public commonService:CommonEventService, public apiServe:ApiService) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    // let headers:any = {
    //   'Content-Type': 'application/json',
    //   'X-Trace-ID' : this.commonService.commonMainObj.fileId
    // };
    // if (localStorage.getItem('token')) {
    //     headers['Authorization'] = 'Bearer ' + this.apiServe.apiMainObj.authorization;
    // }
    // request = request.clone({
    //     setHeaders: headers
    // });
    // const modifiedRequest = request.clone({
    //   setHeaders: {
    //     'X-Trace-ID': this.commonService.commonMainObj.fileId,
    //   },
    // });
    // return next.handle(modifiedRequest)
    const skipUrls = [
      '/superAPI'
    ]
    if(skipUrls.some(url => request.url.includes(url)) || request.method == "DELETE"){
      return next.handle(request)
    }
    return next.handle(request)
    .pipe(
      map((event:HttpEvent<any>)=>{
        if(event instanceof HttpResponse){
          if(window.location.host != 'localhost:4200'){
            if(window.location.pathname != "/ad-dashboard" && event.body == 0 || event.body.status == 0){
              this.commonService.alertCall('Alert!!','Session expired!!');
              this.commonService.goBack();
            }
          }else{
            if(event.body.status == 0){
              event.body.status = 1
            }
          }
        }
        return event;
      }),
      catchError((error: HttpErrorResponse)=>{
        // this.commonService.alertCall('Alert!!',error.message);
        return throwError(() => error.message);
      }))
  }
}
